import * as React from "react";
import { semanticColors } from "~/common/colors/colors";
import { Text, TextProps } from "~/sharedComponents/layout/Text";

export const LabelText: React.FC<TextProps> = props => (
    <Text
        tag="div"
        truncate={true}
        small={true}
        weight="normal"
        paddingBottom={4} // sync with @var-label-height
        color={semanticColors.neutral.text.tertiary}
        {...props}
    />
);
